export default {
  intro: 'Please fill in your credit card information!',
  ccNumber: 'Card Number',
  expDate: 'Expiry Date',
  cvv: 'CVV',
  submit: 'Submit',
};
